define('GeoLocation.EntryPoint',
  [
    'GeoLocation.Service'
  ],
  function (
    GeoLocationService
  ) {
    'use strict';

    return {
      mountToApp: function mountToApp() {
        
        GeoLocationService.getLocation();
      }
    };
  }
);
